import React from "react";
import "./shell.css";

export default function MobileShell({ children, reelsActive = false, lockScroll = false }) {
  return (
    <div className="app-shell app-shell--mobile">
      <main
        className={`app-shell__content app-shell__content--mobile${
          reelsActive ? " app-shell__content--mobile-reels" : ""
        }${lockScroll ? " app-shell__content--mobile-locked" : ""}`}
      >
        {children}
      </main>
    </div>
  );
}
